import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hidden xl:block overflow-x-auto"
}
const _hoisted_2 = { class: "min-w-full divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_3 = { class: "bg-gray-50 dark:bg-black" }
const _hoisted_4 = { class: "bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700" }
const _hoisted_5 = {
  key: 1,
  class: "xl:hidden divide-y divide-gray-200 dark:divide-gray-700"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SkeletonLoader',
  props: {
    type: {},
    rows: {},
    columns: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.type === 'table')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", _hoisted_3, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: col,
                  scope: "col",
                  class: "px-3 sm:px-6 py-4 text-center"
                }, _cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "h-4 bg-gray-300 dark:bg-gray-600 rounded animate-pulse" }, null, -1)
                ])))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row,
                class: "odd:bg-white even:bg-gray-25 dark:odd:bg-gray-900 dark:even:bg-gray-800"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: col,
                    class: "px-3 sm:px-6 py-4 whitespace-nowrap text-center"
                  }, _cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "h-4 bg-gray-200 dark:bg-gray-800 rounded animate-pulse" }, null, -1)
                  ])))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ]))
    : (_ctx.type === 'card')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              key: row,
              class: "p-4 space-y-3"
            }, _cache[2] || (_cache[2] = [
              _createStaticVNode("<div class=\"flex items-center justify-between\" data-v-378860f8><div class=\"h-5 bg-gray-200 dark:bg-gray-800 rounded w-32 animate-pulse\" data-v-378860f8></div><div class=\"h-6 bg-gray-200 dark:bg-gray-800 rounded w-20 animate-pulse\" data-v-378860f8></div></div><div class=\"space-y-1\" data-v-378860f8><div class=\"h-4 bg-gray-200 dark:bg-gray-800 rounded w-16 animate-pulse\" data-v-378860f8></div><div class=\"h-4 bg-gray-200 dark:bg-gray-800 rounded w-48 animate-pulse\" data-v-378860f8></div></div><div class=\"grid grid-cols-2 gap-3\" data-v-378860f8><div class=\"space-y-1\" data-v-378860f8><div class=\"h-4 bg-gray-200 dark:bg-gray-800 rounded w-16 animate-pulse\" data-v-378860f8></div><div class=\"h-4 bg-gray-200 dark:bg-gray-800 rounded w-8 animate-pulse\" data-v-378860f8></div></div><div class=\"space-y-1\" data-v-378860f8><div class=\"h-4 bg-gray-200 dark:bg-gray-800 rounded w-12 animate-pulse\" data-v-378860f8></div><div class=\"h-4 bg-gray-200 dark:bg-gray-800 rounded w-8 animate-pulse\" data-v-378860f8></div></div></div><div class=\"flex gap-2 pt-3 border-t border-gray-100 dark:border-gray-700\" data-v-378860f8><div class=\"flex-1 h-9 bg-gray-200 dark:bg-gray-800 rounded animate-pulse\" data-v-378860f8></div><div class=\"flex-1 h-9 bg-gray-200 dark:bg-gray-800 rounded animate-pulse\" data-v-378860f8></div><div class=\"flex-1 h-9 bg-gray-200 dark:bg-gray-800 rounded animate-pulse\" data-v-378860f8></div></div>", 4)
            ])))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}
}

})